import React, { useState } from "react";
import { useForm } from "react-hook-form";
import InputMask from "react-input-mask";
import emailjs from "emailjs-com";
import { format } from "date-fns";


const currentDate = format(new Date(), "yyyy-MM-dd");

const Devis = () => {
  const [step, setStep] = useState(1);
  const [isCustomFunction, setIsCustomFunction] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch
  } = useForm();

  const validatePhoneNumber = (value) => {
    const isValid = /^[0-9+-]+$/.test(value);
    const isMaskedValid = value.length === 17; // Vérifie si la valeur a la longueur du masque "+999-999-99-99-99"
    return (isValid && isMaskedValid) || "Veuillez entrer un numéro de téléphone valide";
  };

  const onSubmit = (data) => {
    if (step === 3) {
      if (data.websiteType === "Autre") {
        data.websiteType = data.customWebsiteType;
      }
      emailjs
        .send("service_enf8wll", "template_9yte48w", data, "2eB9Q6psF2gmI05X7")
        .then((response) => {
          console.log("Message envoyé avec succès!", response.status, response.text);
          resetForm();
        })
        .catch((error) => {
          console.error("Une erreur s'est produite lors de l'envoi du message:", error);
        });
    } else {
      setStep(step + 1);
    }
  };

  const resetForm = () => {
    setValue("name", "");
    setValue("email", "");
    setValue("phone", "");
    setValue("address", "");
    setValue("websiteType", "");
    setValue("function", "");
    setValue("customFunction", "");
    setValue("technology", "");
    setValue("desiredDate", "");
    setValue("message", "");
    setStep(1);
  };

  const renderStepOne = () => (
    <div className="step">
      <div className="form-group">
        <input {...register("name", { required: true })} type="text" name="name" placeholder="Nom" />
        {errors.name && <span className="invalid-feedback">Veuillez insérer votre nom</span>}
      </div>
      <div className="form-group">
        <input
          {...register("email", {
            required: "Veuillez insérer votre adresse e-mail",
            pattern: {
              value: /\S+@\S+\.\S+/,
              message: "La valeur saisie ne correspond pas au format de l'e-mail"
            }
          })}
          type="email"
          name="email"
          placeholder="Adresse e-mail"
        />
        {errors.email && <span className="invalid-feedback">{errors.email.message}</span>}
      </div>
      <div className="form-group">
        <InputMask
          {...register("phone", {
            required: true,
            validate: validatePhoneNumber
          })}
          mask="+999-999-99-99-99"
          maskChar=""
          type="tel"
          name="phone"
          placeholder="Numéro de téléphone (+xxx-xxx-xx-xx-xx)"
          inputMode="numeric"
        />
        {errors.phone && <span className="invalid-feedback">{errors.phone.message}</span>}
      </div>
      <div className="form-group">
        <input
          {...register("address", { required: true })}
          type="text"
          name="address"
          placeholder="Adresse"
        />
        {errors.address && <span className="invalid-feedback">Veuillez insérer votre adresse</span>}
      </div>
      <button type="submit" className="button">
        Suivant
      </button>
    </div>
  );

  const renderStepTwo = () => (
    <div className="step">
      <div className="form-group">
        <label>Type de Site Web</label>
        <select {...register("websiteType", { required: true })} name="websiteType">
          <option value="">Sélectionnez le type de site web</option>
          <option value="Site personnel">Site personnel</option>
          <option value="Site vitrine">Site vitrine</option>
          <option value="Site e-commerce">Site e-commerce</option>
          <option value="Site d'entreprise">Site d'entreprise</option>
        </select>
        {errors.websiteType && (
          <span className="invalid-feedback">Veuillez sélectionner le type de site web</span>
        )}
      </div>
      <div className="form-group">
        <label>Quelles sont les fonctionnalités que vous souhaitez ajouter sur votre site web ?</label>
        <div className="checkbox-group">
          <label>
            <input type="checkbox" {...register("function")} value="Aucune fonctionnalité" />
            Aucune fonctionnalité
          </label>
          <label>
            <input type="checkbox" {...register("function")} value="Module de demande de devis" />
            Module de demande de devis
          </label>
          <label>
            <input type="checkbox" {...register("function")} value="Module de prise de rendez-vous" />
            Module de prise de rendez-vous
          </label>
          <label>
            <input type="checkbox" {...register("function")} value="Portfolio" />
            Portfolio
          </label>
          <label>
            <input
              type="checkbox"
              {...register("function", { required: false })}
              name="autre"
              onChange={(e) => setIsCustomFunction(e.target.checked)}
            />
            Autre
          </label>
          {isCustomFunction && (
            <input
              type="text"
              {...register("customFunction")}
              name="customFunction"
              placeholder="Autres"
            />
          )}
        </div>
      </div>
      <div className="form-group">
        <input
          {...register("technology", { required: true })}
          type="text"
          name="technology"
          placeholder="Technologie"
        />
        {errors.technology && (
          <span className="invalid-feedback">Veuillez indiquer la technologie souhaitée</span>
        )}
      </div>
      <div className="form-group">
        <input
          {...register("desiredDate", {
            required: true,
            min: currentDate,
            max: "2050-12-31"
          })}
          type="date"
          name="desiredDate"
          placeholder="Date souhaitée"
        />
        {errors.desiredDate && (
          <span className="invalid-feedback">
            {errors.desiredDate.type === "required"
              ? "Veuillez sélectionner la date souhaitée"
              : "Veuillez entrer une date au format jj/mm/aaaa"}
          </span>
        )}
      </div>
      <div className="form-group">
        <textarea
          {...register("message", { required: true })}
          name="message"
          placeholder="Message"
        />
        {errors.message && <span className="invalid-feedback">Veuillez entrer votre message</span>}
      </div>
      <button type="button" className="button" onClick={() => setStep(step - 1)}>
        Précédent
      </button>
      <button type="submit" className="button">
        Suivant
      </button>
    </div>
  );

  const renderStepThree = () => {
    const selectedFunctions = watch("function");
    const selectedCustomFunction = watch("customFunction");

    return (
      <div className="step">
        <h1>Récapitulatif</h1>
        <p>
          <strong>Nom:</strong> {watch("name")}
        </p>
        <p>
          <strong>E-mail:</strong> {watch("email")}
        </p>
        <p>
          <strong>Téléphone:</strong> {watch("phone")}
        </p>
        <p>
          <strong>Adresse:</strong> {watch("address")}
        </p>
        <p>
          <strong>Type de site web:</strong> {watch("websiteType")}
        </p>
        <p>
          <strong>Fonctionnalités:</strong>
          {Array.isArray(selectedFunctions) ? (
            <ul>
              {selectedFunctions.map((option, index) => (
                <li key={index}>{option}</li>
              ))}
            </ul>
          ) : (
            selectedFunctions
          )}
        </p>
        <p>
          <strong>Autre:</strong> {watch("customFunction")}
        </p>
        <p>
          <strong>Technologie:</strong> {watch("technology")}
        </p>
        <p>
          <strong>Date souhaitée:</strong> {watch("desiredDate")}
        </p>
        <p>
          <strong>Message:</strong> {watch("message")}
        </p>
        <button type="button" className="button" onClick={() => setStep(step - 1)}>
          Précédent
        </button>
        <button type="submit" className="button">
          Envoyer
        </button>
      </div>
    );
  };

  return (
    <form className="contactform" onSubmit={handleSubmit(onSubmit)}>
      {step === 1 && renderStepOne()}
      {step === 2 && renderStepTwo()}
      {step === 3 && renderStepThree()}
    </form>
  );
};
export default Devis;
